import React from 'react';
import { Box } from '@mui/material';
import { t } from 'i18next';

type Props = {
    title?: string;
    header: string | number;
    subheader?: string | number;

};

const HeaderCard: React.FC<Props> = ({ title, header, subheader }) => {

    return (
        <Box className="report-header-card" role="region" aria-label={title ? title.toString() : t('reports.completedMappedData.dataGrid.columnGroupHeader.header')}>
            {title && <Box className="report-header-card-title" role="heading" aria-level={3}>
                {title}
            </Box>}

            <Box className="cmd-values two">
                <Box className="cmd-item">
                    <Box className="cmd-header">{header}</Box>
                </Box>
                {subheader && <Box className="cmd-item">
                    <Box className="cmd-sub-header">{subheader}</Box>
                </Box>
                }
            </Box>
        </Box>
    );
};

export default HeaderCard;
